import api from '@/services/utils/base';
import { AxiosPromise } from 'axios';
import { StatusEnum } from '@/services/models/Enums';
import store from '@/store';

export default class Campaign {
  get(id: string){
    return api.get(`campaigns/${id}`).then((res)=>{
      return Promise.resolve(res.data.payload);
    })
  }

  getName(id: string): AxiosPromise<Bemob.Response<Bemob.CampaignName>> {
    return api.get(`campaigns/name/${id}`);
  }

  postCreate(payload: Bemob.Campaign): AxiosPromise<Bemob.Response<Bemob.Campaign>> {
    return api.post('campaigns', payload);
  }

  getList(params:{
    limit?:number,
    status?:StatusEnum.active,
    search?:string,
    workspaceIds?: string[]
    orderBy?:string,
    orderDirection?:string,
  } = {}): Promise<Bemob.Campaign[]> {
    return api.get('campaigns', {params}).then((res: Bemob.RawResponse<Bemob.Campaign[]>) => {
      return Promise.resolve(res.data.payload);
    });
  }

  putUpdate(id: string, payload: Bemob.Campaign) {
    return api.put(`campaigns/${id}`, payload).then((res)=>{
      return Promise.resolve(res.data.payload);
    })
  }

  delete(id: string) {
    return api.delete(`campaigns/${id}`);
  }

  postArchive(payload: object) {
    return api.post('campaigns/archive', payload);
  }

  postRestore(payload: object) {
    return api.post('campaigns/restore', payload);
  }

  postDuplicate(payload: object) {
    return api.post('campaigns/duplicate', payload);
  }

  postUpdateCost(id: string, payload: object) {
    return api.post(`campaigns/${id}/update-cost`, payload);
  }

  count(payload: object) {
    return api.get('campaigns/count', payload);
  }

  bulkUpdate(workspaceId: string, payload: object) {
    return api.put(`/campaigns/workspace/${workspaceId}/bulk-update`, payload);
  }

  putExternalStatus(id: string, payload: {  'status': 'play' | 'stop' }) {
    return api.put(`/v2/campaigns/${id}/external-status`, payload);
  }

  updateStoreCache({workspaceId}) {
    return api.get('campaigns', {
      params:{
        status: StatusEnum.active,
        limit:200,
        orderBy:'updated',
        orderDirection:'desc',
        workspaceIds:[workspaceId]  // not included public workspaces like other caches, because it's not allowed to create campaign in public
      }
    }).then((res)=>{
      store.commit('updateCampaignsCache', {
        workspaceId,
        data:res.data.payload
      });
      return Promise.resolve(res.data.payload);
    })
  }

  populateStoreCache() {
    store.commit('cacheStartUpdating', 'campaigns');
    return api.get('campaigns', {
      params:{
        status: StatusEnum.active,
        limit:200,
        orderBy:'updated',
        orderDirection:'desc',
      }
  }).then((res)=>{
      store.commit('populateCampaignsCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }
}
